import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
	routes: [
		{
			path: '/',
			name: 'FESCO政策通',
			component: () => import('./../components/Home.vue'),
		},
		{
			path: '/index',
			name: '政策列表',
			component: () => import('./../components/index.vue'),
		},
		{
			path: '/querys',
			name: '政策查询',
			component: () => import('./../components/Query.vue'),
		},
		{
			path: '/detail',
			name: '政策详情',
			component: () => import('./../components/detail.vue'),
		},
		{
			path: '/pdf',
			name: '预览文件',
			component: () => import('./../components/Pdf.vue'),
		},
		{
			path: '/img',
			name: '预览文件',
			component: () => import('./../components/ImgPreview.vue'),
		},
    {
			path: '/socialreduct',
			name: '社保减免计算器',
			component: () => import('./../components/SocialReduct.vue'),
		},
    {
			path: '/reductcalculator',
			name: '社保减免计算器',
			component: () => import('./../components/ReductCalculator.vue'),
		},
	],
});

export default router;
